import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{
    padding: '100px 20px', 
    textAlign: 'center', 
    minHeight: '80vh', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center'
  }}>
    <h1 style={{fontSize: '4rem', marginBottom: '20px'}}>404</h1>
    <p style={{marginBottom: '30px', color: 'var(--text-secondary)'}}>Page not found</p>
    <Link to="/" style={{
      padding: '12px 24px', 
      background: 'var(--primary)', 
      color: 'white', 
      borderRadius: '8px',
      textDecoration: 'none'
    }}>
      Back to Home
    </Link>
  </div>
);

export default NotFound;
